package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.repository.CharacterCacheRepository

class ClearCharacterCacheUseCase(private val characterCacheRepository: CharacterCacheRepository) {

    operator fun invoke() {
        characterCacheRepository.clear()
    }
}
